module.exports = "<svg viewBox=\"0 0 299.2 110\"><path d=\"M35.7 28.2c14.2 0 25.7-11.5 25.7-25.7H42.5c0 3.8-3 6.8-6.8 6.8s-6.8-3-6.8-6.8H10.1c0 14.2 11.5 25.7 25.6 25.7z\" class=\"st0\"></path><path d=\"M2.1 35.7v31.5c0 18.6 15 33.6 33.6 33.6s33.6-15 33.6-33.6V35.7H2.1zm33.6 46.1c-8.1 0-14.7-6.6-14.7-14.7V54.6h29.4v12.6c0 8-6.6 14.6-14.7 14.6z\" class=\"st0\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/icon-police.svg
// module id = 290
// module chunks = 1